// Cart Auto-add
window.addEventListener("abra:cart:changed", () => {
    document.documentElement.dispatchEvent(
      new CustomEvent("cart-drawer:refresh-items", {
        bubbles: true,
      })
    );
  });

// Featured Product variant clicks
document.addEventListener('click', (e) => {
  const btn = e.target?.closest?.('.fp__variant-btn');
  if (!btn) return;
  window.dispatchEvent(new CustomEvent('fp:variant:clicked', {
    detail: {
      variantId: btn.getAttribute('data-variant-id'),
      price: btn.getAttribute('data-variant-price'),
      title: btn.getAttribute('data-variant-title'),
    },
  }));
});

// Keep the selected PDP variant in the URL 
window.addEventListener('load', () => {
  const variantButtons = document.querySelectorAll('.gf-vbtn');
  if (!variantButtons.length) return;
  
  const setVariantInUrl = (variantId) => {
    if (!variantId) return;
  
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', url.toString());
  };
  
  const activeBtn = document.querySelector('.gf-vbtn--active');
  if (activeBtn?.dataset.variantId) {
    setVariantInUrl(activeBtn.dataset.variantId);
  }
  
  variantButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const variantId = btn.dataset.variantId;
      if (!variantId) return;
  
      setVariantInUrl(variantId);
      window.dispatchEvent(new CustomEvent('gf:variant:clicked', {
        detail: { variantId },
      }));
      });
    });
  });

// Helper function to keep the variant id in sync with the active button
(() => {
  const states = new Map();

  const sync = (card, id) => {
    const wrap = card.querySelector('.fp__price-wrap');
    if (wrap) wrap.dataset.variantId = id;
  };

  const restoreAll = () => states.forEach((id, card) => document.contains(card) && sync(card, id));

  const init = () => document.querySelectorAll('.product-card').forEach(card => {
    const active = card.querySelector('.fp__variant-btn.active');
    if (active) { states.set(card, active.dataset.variantId); sync(card, active.dataset.variantId); }

    card.querySelectorAll('.fp__variant-btn:not([data-listener])').forEach(btn => {
      btn.dataset.listener = 1;
      btn.addEventListener('click', function () {
        states.set(card, this.dataset.variantId);
        sync(card, this.dataset.variantId);
        window.Abra?.render();
        setTimeout(restoreAll, 10);
      });
    });
  });

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
  new MutationObserver(init).observe(document.body, { childList: true, subtree: true });
})();